// src/pages/use-reward/types.ts
export interface Languages {
    [key: string]: {
        instructions_image: string;
    };
}


export interface InitialData {
  qrscan_image?: string;
  reward_banner?: string;
  banner_image_corner?: string;
  used_at?: string;
  expired_at?: string;
  coupon_code?: string;
  coupon_used_option?: string;
  is_3rdparty_coupon_use?: boolean;
  is_for_verified_users?: boolean;
  is_line_verified?: boolean;
  remain_quantity?: number;
  is_expired_or_finished_issued?: boolean;
  subcampaign_id?: string;
  languages?: Languages;
}


export type CouponStatusType = "COMPLETED" | "PENDING" | "ENGAGED" | "VERIFIED";


export enum CouponTypeEnum {
    REDEEM = "REDEEM",
    DISCOUNT = "DISCOUNT",
    QUO_PAY = "QUO_PAY",
    TOKYU_POINTS = "TOKYU_POINTS",
}


export interface CouponDetail extends InitialData {
    status: CouponStatusType;
    coupon_type?: CouponTypeEnum;
    sending_message_platform?: string;
    advertiser_banner?: string;
    loyalty_member_id?: string;
    is_loyalty_submitted?: boolean;
    is_multi_coupons?: boolean;
    banner_image_corner?: string;
    is_paypay?: boolean;
    is_paypay_consent_completed?: boolean;
    coupon_session?: string;
    external_coupon_amount?: number;
    create_date?: string;
    coupon_reference?: string;
    external_code?: string;
}
